<script>
    import { getContext } from 'svelte';
    import { writable } from 'svelte/store';
    import { geoMercator } from 'd3-geo';

    import MapNavigator from './MapNavigator.svelte';
    import MapStreets from './MapStreets.svelte';
    import MapLegend from './MapLegend.svelte';
    import MapPoints from './MapPoints.svelte';
    import MapTooltip from './MapTooltip.svelte';
    import MapTrajectory from './MapTrajectory.svelte';
    import MapPOI from './MapPOI.svelte';

    // --- Properties
    export let dataKey;
    const { selector, trajectory, showStops, showPOIs } = getContext(dataKey);

    const width = 800;
    const height = 480;
    const zoomSpeed = 0.06;

    // --- Projection
    const projection = geoMercator()
        .scale(600000)
        .translate([0, 0])
        .rotate([-24.867, -36.069]);

    // --- Navigation
    let tooltip = writable();
    let navigator;
    const viewbox = writable([-width / 2, -height / 2, width, height]);
</script>

<MapTooltip bind:handles={$tooltip} />
<MapNavigator {viewbox} {zoomSpeed} bind:handles={navigator} />
<svelte:window
    on:mouseup={navigator.stop}
    on:mousemove={(e) => {
        navigator.move(e);
        $tooltip.move(e);
    }}
/>

<div id="map" style="width:{width}px;height:{height}px;">
    <svg
        {width}
        {height}
        viewBox={`${$viewbox[0]} ${$viewbox[1]} ${$viewbox[2]} ${$viewbox[3]}`}
        on:mousedown={navigator.start}
        on:mousewheel|preventDefault={navigator.zoom}
        on:click={(e) => selector.reset(e, 'circle')}
        on:dblclick={navigator.reset}
    >
        <MapStreets {dataKey} {projection} />
        {#if $showStops}
            <MapPoints {dataKey} {projection} {tooltip} />
            <MapTrajectory {dataKey} {projection} bind:handles={$trajectory} />
        {/if}
        {#if $showPOIs}
            <MapPOI {dataKey} {projection} {tooltip} />
        {/if}
    </svg>
    <MapLegend />
</div>

<style>
    #map {
        position: relative;
        margin-right: 5px;
    }
</style>
